import { Navigate, Route, Routes } from "react-router-dom";
import AdminLayout from "./layout/AdminLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import RoleRoute from "./components/RoleRoute";
import DashboardPage from "./pages/DashboardPage";
import ProductsPage from "./pages/ProductsPage";
import CategoriesPage from "./pages/CategoriesPage";
import EventPropsPage from "./pages/EventPropsPage";
import QuotationsPage from "./pages/QuotationsPage.jsx";
import SalesPage from "./pages/SalesPage.jsx";
import MessagesPage from "./pages/MessagesPage";
import AboutPage from "./pages/AboutPage";
import SettingsPage from "./pages/SettingsPage";
import LoginPage from "./pages/LoginPage";
import UsersPage from "./pages/UsersPage";
import AdminsPage from "./pages/AdminsPage";
import InventoryPage from "./pages/InventoryPage";
import AnnouncementsPage from "./pages/AnnouncementsPage";
import {
  canAccessAbout,
  canAccessAdmins,
  canAccessDashboard,
  canAccessMessages,
  canAccessProducts,
  canAccessQuotations,
  canAccessSales,
  canAccessSettings,
  canAccessUsers
} from "./utils/auth";

const App = () => (
  <Routes>
    <Route path="/login" element={<LoginPage />} />
    <Route element={<ProtectedRoute />}>
      <Route element={<AdminLayout />}>
        <Route path="/inventory" element={<InventoryPage />} />
        <Route path="/announcements" element={<RoleRoute allow={canAccessAdmins}><AnnouncementsPage /></RoleRoute>} />
        <Route path="/" element={<RoleRoute allow={canAccessDashboard}><DashboardPage /></RoleRoute>} />
        <Route path="/products" element={<RoleRoute allow={canAccessProducts}><ProductsPage /></RoleRoute>} />
        <Route path="/categories" element={<RoleRoute allow={canAccessProducts}><CategoriesPage /></RoleRoute>} />
        <Route path="/event-props" element={<RoleRoute allow={canAccessProducts}><EventPropsPage /></RoleRoute>} />
        <Route path="/quotations" element={<RoleRoute allow={canAccessQuotations}><QuotationsPage /></RoleRoute>} />
        <Route path="/sales" element={<RoleRoute allow={canAccessSales}><SalesPage /></RoleRoute>} />
        <Route path="/messages" element={<RoleRoute allow={canAccessMessages}><MessagesPage /></RoleRoute>} />
        <Route path="/users" element={<RoleRoute allow={canAccessUsers}><UsersPage /></RoleRoute>} />
        <Route path="/admins" element={<RoleRoute allow={canAccessAdmins}><AdminsPage /></RoleRoute>} />
        <Route path="/about" element={<RoleRoute allow={canAccessAbout}><AboutPage /></RoleRoute>} />
        <Route path="/settings" element={<RoleRoute allow={canAccessSettings}><SettingsPage /></RoleRoute>} />
      </Route>
    </Route>
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default App;
